import { clearAccountsTableFilterSession } from './accountsTableFilterSession';

export const ACCOUNTS_SEARCH_FILTER_QUERY = 'dd_account_search';

export type AccountsSearchSessionValue = {
  input: string;
  select: string;
  submitable?: boolean;
  customHandler?: boolean;
  synced?: boolean;
};

const searchByKey = new Map<string, AccountsSearchSessionValue>();

const memoryKey = (uid: string, query: string): string => `${uid}.${query}`;

export const isAccountsSearchSessionValue = (
  value: unknown
): value is AccountsSearchSessionValue => {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const candidate = value as AccountsSearchSessionValue;
  return (
    candidate.input !== undefined &&
    candidate.select !== undefined &&
    typeof candidate.select === 'string'
  );
};

export const getAccountsSearchSession = (
  uid: string,
  query: string = ACCOUNTS_SEARCH_FILTER_QUERY
): AccountsSearchSessionValue | null => {
  if (!uid) {
    return null;
  }
  return searchByKey.get(memoryKey(uid, query)) ?? null;
};

export const setAccountsSearchSession = (
  uid: string,
  query: string,
  value: AccountsSearchSessionValue
): void => {
  if (!uid || !query) {
    return;
  }
  searchByKey.set(memoryKey(uid, query), { ...value });
};

export const clearAccountsSearchSession = (uid?: string): void => {
  if (!uid) {
    searchByKey.clear();
    clearAccountsTableFilterSession();
    return;
  }
  const prefix = `${uid}.`;
  Array.from(searchByKey.keys()).forEach((key) => {
    if (key.startsWith(prefix)) {
      searchByKey.delete(key);
    }
  });
  clearAccountsTableFilterSession(uid);
};
